import { GetterTree } from 'vuex'
import { ManagementTemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ManagementTemplatesState, RootState> = {
    managementTemplates:state => state.managementTemplates,
    managementTemplatesStatus:state => state.managementTemplatesStatus,
};
